<template>
  <div
    v-if="show"
    class="modal"
  >
    <div class="modal-content">
      <v-row class="m-0">
        <v-col class="p-0">
          <h4 class="modal-title">
            <v-icon
              size="40"
              color="#ffffff"
            >
              mdi-information-outline
            </v-icon>
            <span
              v-if="title.length"
              style="color: #fff; font-size: 22px;"
            >
              {{ title }}
            </span>
          </h4>
        </v-col>
      </v-row>
      <v-row class="m-0">
        <p
          v-if="!isReleaseNote"
          class="modal-message"
        >
          {{ message }}
        </p>
        <quillEditor
          v-else
          v-model="message"
          :disabled="true"
          :options="{modules: {toolbar: false}}"
        />
      </v-row>
      <v-row class="m-0">
        <v-col
          cols="5"
        >
          <VCheckbox
            v-if="isReleaseNote"
            v-model="dontShowAgain"
            :label="$t('forms.labels.dontShowAgain')"
          />
        </v-col>
        <v-col>
          <button
            class="modal-btn d-flex"
            @click="closeModal"
          >
            {{ $t('forceUpdate.continue') }}
          </button>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import VCheckbox from '@/components/shared/widgets/forms/VuetifyInputs/VCheckbox';
import { quillEditor } from 'vue-quill-editor';

export default {
    components: {
        VCheckbox,
        quillEditor,
    },
    props: {
        show: {
            type: Boolean,
            default: false,
        },
        title: {
            type: String,
            default: '',
        },
        message: {
            type: String,
            default: 'Default Message',
        },
        isReleaseNote: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            dontShowAgain: false,
        };
    },
    methods: {
        closeModal() {
            this.$emit('close', this.dontShowAgain);
        },
    },
};
</script>

<style scoped lang="scss">
.modal {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 99999;
    padding: 20px;
}
.modal-content {
    background: white;
    width: 800px;
    border-radius: 5px;
    text-align: center;
    max-height: 600px;
    overflow-y: auto;
}
.modal-title {
    background: #2A3E53;
    padding: 10px;
    font-size: 25px;
}
.modal-btn {
    background: #2A3E53;
    color: white;
    border: none;
    padding: 10px;
    margin: 10px;
    border-radius: 20px;
    cursor: pointer;
}
.modal-message {
    padding: 10px;
}
</style>
